import { gql } from '@apollo/client';

const getUserSubscription = gql`
  query getUserSubscription {
    getUser {
      userEntitlements {
        LMOD {
          vimeoUserTicket
        }
      }
      vimeoUserId
      paymentMethod {
        email
      }
      lmodSubscription {
        canceled_at
      }
    }
  }
`;

export default getUserSubscription;